import { AutoComplete, useFormContext } from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import { memo, useMemo } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TTicketAutoTransferRuleForm } from "../TicketAutoTransferRuleSchema";
import { useTicketChannelSteps } from "./useTicketChannelSteps";
import TicketChannel from "../TicketChannel";

const translationPath = "page.settings.crm.ticketAutoTransferRules.";

export const TicketChannelStepTransfer = memo(() => {
  const { t } = useTranslation();

  const { control } = useFormContext<TTicketAutoTransferRuleForm>();

  const { ticketChannelSteps } = useTicketChannelSteps(
    "ticketChannelTransfer",
    { notFinish: true }
  );

  const ticketChannelStepField = useWatch({
    name: "ticketChannelStep",
    control,
  });

  const ticketChannelStepTransferOptions = useMemo(
    () =>
      ticketChannelStepField
        ? ticketChannelSteps.filter(
            (item) => item.id !== ticketChannelStepField.id
          )
        : ticketChannelSteps,
    [ticketChannelStepField, ticketChannelSteps]
  );

  return (
    <Grid item xs={12} marginY={6}>
      <Typography variant="h6" sx={{ fontWeight: "bold", marginBottom: 2 }}>
        {t(translationPath + "transfer_to") + ":"}
      </Typography>

      <Grid container spacing={2}>
        <TicketChannel
          name="ticketChannelTransfer"
          ticketChannelStepFieldName="ticketChannelStepTransfer"
        />

        <Grid item xs={12} sm={6}>
          <AutoComplete
            getOptionLabel={(option) => {
              return option.name;
            }}
            size="small"
            label={t(translationPath + "ticket_channel_step_transfer")}
            name="ticketChannelStepTransfer"
            options={ticketChannelStepTransferOptions}
          />
        </Grid>
      </Grid>
    </Grid>
  );
});
